module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "pre"
    }
  }), _c('strong', [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The battle of Surigao Strait was one of four major actions that compose the larger grand naval battle known collectively as the battle of Leyte Gulf."), _c('a', {
    attrs: {
      "id": "rpreen1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#preen1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" The four battles grouped under that name are the battles of the Sibuyan Sea, Cape Engano, Samar, and Surigao Strait. The last battle and its associated operations are the subject of this volume. The battle of Surigao Strait is significant as the last surface battle between capital ships in WWII, and indeed, to date."), _c('a', {
    attrs: {
      "id": "rpreen2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#preen2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" As such, Surigao Strait seems an appropriate volume for the "), _c('em', [_vm._v("Twentieth Century Battles")]), _vm._v(" series.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although we are now more than sixty years removed from events, there has been no comprehensive treatment of the Surigao action since the "), _c('em', [_vm._v("Naval War College Analysis of 1958")]), _vm._v(" of R. W. Bates and the closely intertwined volume 12, "), _c('em', [_vm._v("Leyte")]), _vm._v(", of S. E. Morison’s "), _c('em', [_vm._v("History of U.S. Naval Operations in WW II")]), _vm._v(". There is a group of excellent accounts of the battle of Leyte Gulf itself, particularly the battle of Samar, but Surigao is not among them. Such a treatment is both warranted and necessary, particularly at the operational level. The received record is in need of fundamental revision. In key places, it simply is not factually correct or sound in ways that extend beyond simple minutiae.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The present book had its beginnings when online articles I wrote in 1997 and 1999 to address recurring errors in the record spurred interest in the persisting mysteries, contradictions, and unanswered questions of the accepted account."), _c('a', {
    attrs: {
      "id": "rpreen3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#preen3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" These articles documented in detail how the conventional record has come down to us, and noted its weaknesses as well as its contradictions. In the interval, inspired by these articles, the diving community, and particularly John Bennett Deep Ocean Research International and the Discovery Channel, began in late 2000 to investigate some of these mysteries with a plan to locate and film the wrecks of the underwater battlefield of Surigao. I served as a historical consultant and fact-checker."), _c('a', {
    attrs: {
      "id": "rpreen4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#preen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like many such long-term endeavors, the diving project has stopped and restarted and stopped again several times over the years since 2000."), _c('a', {
    attrs: {
      "id": "rpreen5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#preen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" In the "), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("meantime I expanded my research, having discovered further aspects of the received account that do not stand up to scrutiny. Even if no wreck details were learned, there was ample new ground to break by more conventional means: a reexamination of all known available primary sources; attention to the neglected testimony of Japanese captured at Surigao; and most importantly, translation of modern Japanese sources to be found and arranged from contacts in Japan. In several places, this account differs radically from the received record and represents a major revision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the caveat that in the historian’s work certainties are few, it can reasonably be asserted that the book resolves some significant riddles of the battle of Surigao Strait and misinterpretation in the record regarding the purposes of Vice Admiral Nishimura’s mission. Among these is the enigma of the sinking of battleship "), _c('em', [_vm._v("Fuso")]), _vm._v(", and the perplexing claim in prior accounts that she exploded and remained afloat in two burning sections. What really happened proves as interesting as the solution of a crime. Another is the actual intent of the orders issued by vice admirals Nishimura and Shima. Some other key questions about Surigao events raised by H. P. Willmott in his recent study of Leyte Gulf also find answer here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Due to the wholesale loss and destruction of most of the Japanese ships and personnel of the Third Section, and later similar loss to those of Second Striking Force, it has been necessary to tell the Japanese side of the story through the perspective of eyewitnesses. Wherever possible these accounts have been checked against the known chronology and surviving records to constrain any inaccuracies. In some places, the laws of physics and basic logistical considerations drive the conclusions. In the final accounting, any responsibility for misinterpretation or overlooked errors rests is mine alone.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769c4412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 81
// module chunks = 0